module.exports = __webpack_public_path__ + "img/cancel.8e137767.svg";